// extracted by mini-css-extract-plugin
export default {"e_learning_wrapper":"ELearning_e_learning_wrapper__a3J9V","e_learning_italics":"ELearning_e_learning_italics__tkiLI"};